import { API } from '../../utils/http'

const state = {
  realName: '',
  avatarUrl: '',
  courtCount: '',
  classPerformance: '',
  classPerformanceType: ['excellent', 'veryGood', 'good', 'fair'],
  classNum: 0,
  studentNum: 0,
  studentId: '',
  classTotalNumSituation: {},
  coursePackage: [],
  classInfo: [],
  cumulativeWork: {},
  semesterWork: {},
  workStarSituation: {},
  teacherClassPerformance: {},
  hasWorkStarSituationData: true,
  studentInnovativeThinkingScore: {},
  studentArtDesignScore: {},
  studentLogicalThinkingScore: {},
  studentProgrammingTechnologyScore: {},
  studentComprehensiveScoreScore: {},
  teacherWorkCumulativeWork: {},
  teacherWorkSemesterWork: {},
  teacherClassName: {},
  teacherWorkStarTableData: {},
  teacherClassAverageRank: {},
  teacherInnovativeThinkingScore: {},
  teacherArtDesignScore: {},
  teacherLogicalThinkingScore: {},
  teacherProgrammingTechnologyScore: {},
  teacherComprehensiveScoreScore: {}
}

const actions = {
  getStudentBaseInfo({ dispatch }) {
    let params = {}
    if (state.studentId !== '') {
      params = {
        type: 1,
        student_id: state.studentId
      }
    }
    dispatch('getStudentInfo', params)
    dispatch('getStudentClassNumAndClassPerformance', params)
    dispatch('getStudentOpenCourse', params)
    dispatch('getStudentClassNameAndTeacher', params)
  },
  getStudentInfo({ commit }, params) {
    API.get(`/edu/zone/analysis/student/info`, params).then(res => {
      if (res.status < 400) {
        commit('getStudentInfo', res.data)
      }
    })
  },
  getStudentClassNumAndClassPerformance({ commit }, params) {
    API.get(`/edu/zone/analysis/student/course`, params).then(res => {
      if (res.status < 400) {
        commit('getStudentClassNumAndClassPerformance', res.data)
      }
    })
  },
  getStudentOpenCourse({ commit }, params) {
    API.get(`/edu/zone/analysis/student/packages`, params).then(res => {
      if (res.status < 400) {
        commit('getStudentOpenCourse', res.data)
      }
    })
  },
  getStudentClassNameAndTeacher({ commit }, params) {
    API.get(`/edu/zone/analysis/student/class/info`, params).then(res => {
      if (res.status < 400) {
        commit('getStudentClassNameAndTeacher', res.data)
      }
    })
  },
  getWorkStatusData({ dispatch }) {
    let params = {}
    if (state.studentId !== '') {
      params = {
        type: 1,
        student_id: state.studentId
      }
    }
    dispatch('getStudentWorkSituation', params)
    dispatch('getStudentWorkStarSituation', params)
  },
  getStudentWorkSituation({ commit }, params) {
    API.get(`/edu/zone/analysis/student/works/situations`, params).then(res => {
      if (res.status < 400) {
        commit('getStudentWorkSituation', res.data)
      }
    })
  },
  getStudentWorkStarSituation({ commit }, params) {
    API.get(`/edu/zone/analysis/student/works/star/info`, params).then(res => {
      if (res.status < 400) {
        commit('getStudentWorkStarSituation', res.data)
      }
    })
  },
  getStudentAbilityDimension({ dispatch }) {
    let params = {}
    if (state.studentId !== '') {
      params = {
        type: 1,
        student_id: state.studentId
      }
    }
    dispatch('getStudentInnovativeThinkingScore', params)
    dispatch('getStudentArtDesignScore', params)
    dispatch('getStudentLogicalThinkingScore', params)
    dispatch('getStudentProgrammingTechnologyScore', params)
    dispatch('getStudentComprehensiveScoreScore', params)
  },
  getStudentInnovativeThinkingScore({ commit }, params) {
    API.get(
      `/edu/zone/analysis/student/ability/creative/dimensions`,
      params
    ).then(res => {
      if (res.status < 400) {
        commit('getStudentInnovativeThinkingScore', res.data)
      }
    })
  },
  getStudentArtDesignScore({ commit }, params) {
    API.get(
      `/edu/zone/analysis/student/ability/artistic/dimensions`,
      params
    ).then(res => {
      if (res.status < 400) {
        commit('getStudentArtDesignScore', res.data)
      }
    })
  },
  getStudentLogicalThinkingScore({ commit }, params) {
    API.get(
      `/edu/zone/analysis/student/ability/logical/dimensions`,
      params
    ).then(res => {
      if (res.status < 400) {
        commit('getStudentLogicalThinkingScore', res.data)
      }
    })
  },
  getStudentProgrammingTechnologyScore({ commit }, params) {
    API.get(
      `/edu/zone/analysis/student/ability/programming/dimensions`,
      params
    ).then(res => {
      if (res.status < 400) {
        commit('getStudentProgrammingTechnologyScore', res.data)
      }
    })
  },
  getStudentComprehensiveScoreScore({ commit }, params) {
    API.get(`/edu/zone/analysis/student/ability/radars`, params).then(res => {
      if (res.status < 400) {
        commit('getStudentComprehensiveScoreScore', res.data)
      }
    })
  },
  getTeacherBaseInfo({ dispatch }) {
    dispatch('getTeacherInfo')
    dispatch('getTeacherClassNumAndStudentNum')
    dispatch('getTeacherOpenCourse')
    dispatch('getTeacherClassCount')
    dispatch('getTeacherClassPerformance')
    dispatch('getTeacherClassAverageRank')
  },
  getTeacherInfo({ commit }) {
    API.get(`/edu/zone/analysis/teacher/info`).then(res => {
      if (res.status < 400) {
        commit('getTeacherInfo', res.data)
      }
    })
  },
  getTeacherClassNumAndStudentNum({ commit }) {
    API.get(`/edu/zone/analysis/teacher/class/count`).then(res => {
      if (res.status < 400) {
        commit('getTeacherClassNumAndStudentNum', res.data)
      }
    })
  },
  getTeacherOpenCourse({ commit }) {
    API.get(`/edu/zone/analysis/teacher/lesson/packages`).then(res => {
      if (res.status < 400) {
        commit('getTeacherOpenCourse', res.data)
      }
    })
  },
  getTeacherClassCount({ commit }) {
    API.get(`/edu/zone/analysis/teacher/cumulative/course/count`).then(res => {
      if (res.status < 400) {
        commit('getTeacherClassCount', res.data)
      }
    })
  },
  getTeacherClassPerformance({ commit }) {
    API.get(`/edu/zone/analysis/teacher/lessons/performance/score`).then(
      res => {
        if (res.status < 400) {
          commit('getTeacherClassPerformance', res.data)
        }
      }
    )
  },
  getTeacherClassAverageRank({ commit }, pageNum) {
    const page = pageNum === 1 || pageNum === undefined ? 1 : pageNum
    API.get(
      `/edu/zone/analysis/teacher/class/avg/score/rank?page=${page}&limit=7`
    ).then(res => {
      if (res.status < 400) {
        commit('getTeacherClassAverageRank', res.data)
      }
    })
  },
  getTeacherWorkSituation({ dispatch }) {
    dispatch('getTeacherWorkSituationChartData')
    dispatch('getTeacherWorkCumulativeWork')
    dispatch('getTeacherWorkSemesterWork')
    dispatch('getTeacherWorkStarSituation')
    dispatch('getTeacherWorkStarTable')
  },
  getTeacherWorkSituationChartData({ commit }) {
    API.get(`/edu/zone/analysis/teacher/work/situation`).then(res => {
      if (res.status < 400) {
        commit('getTeacherWorkSituationChartData', res.data)
      }
    })
  },
  getTeacherWorkCumulativeWork({ commit }, pageNum) {
    const page = pageNum === 1 || pageNum === undefined ? 1 : pageNum
    API.get(
      `/edu/zone/analysis/teacher/cumulative/work/situation?page=${page}&limit=6`
    ).then(res => {
      if (res.status < 400) {
        commit('getTeacherWorkCumulativeWork', res.data)
      }
    })
  },
  getTeacherWorkSemesterWork({ commit }, pageNum) {
    const page = pageNum === 1 || pageNum === undefined ? 1 : pageNum
    API.get(
      `/edu/zone/analysis/teacher/work/semester/situation?page=${page}&limit=6`
    ).then(res => {
      if (res.status < 400) {
        commit('getTeacherWorkSemesterWork', res.data)
      }
    })
  },
  getTeacherWorkStarSituation({ commit }) {
    API.get(`/edu/zone/analysis/teacher/works/stars`).then(res => {
      if (res.status < 400) {
        commit('getTeacherWorkStarSituation', res.data)
      }
    })
  },
  getTeacherWorkStarTable({ commit }, pageNum) {
    const page = pageNum === 1 || pageNum === undefined ? 1 : pageNum
    API.get(
      `/edu/zone/analysis/teacher/class/works/stars?page=${page}&limit=6`
    ).then(res => {
      if (res.status < 400) {
        commit('getTeacherWorkStarTable', res.data)
      }
    })
  },
  getTeacherClassSituation({ dispatch }) {
    dispatch('getTeacherClass')
  },
  getTeacherClass({ commit }, studentName) {
    let url = ''
    if (studentName !== undefined && studentName !== '') {
      url = `/edu/zone/analysis/teacher/class?student_name=${studentName}`
    } else {
      url = `/edu/zone/analysis/teacher/class`
    }
    API.get(`${url}`).then(res => {
      if (res.status < 400) {
        commit('getTeacherClass', res.data)
      }
    })
  },
  searchTeacherClass({ commit }, classInfo) {
    let searchCriteria = ''
    if (classInfo.studentName === '') {
      searchCriteria = `page=${classInfo.page}&limit=6`
    } else {
      searchCriteria = `student_name=${classInfo.studentName}&page=${
        classInfo.page
      }&limit=6`
    }
    API.get(`/edu/zone/analysis/teacher/class?${searchCriteria}`).then(res => {
      if (res.status < 400) {
        commit('getTeacherClass', res.data)
      }
    })
  },
  getTeacherAbilityDimension({ dispatch }, params) {
    dispatch('getTeacherInnovativeThinkingScore', params)
    dispatch('getTeacherArtDesignScore', params)
    dispatch('getTeacherLogicalThinkingScore', params)
    dispatch('getTeacherProgrammingTechnologyScore', params)
    dispatch('getTeacherComprehensiveScoreScore', params)
  },
  getTeacherInnovativeThinkingScore({ commit }, params) {
    API.get(
      `/edu/zone/analysis/teacher/ability/creative/dimensions`,
      params
    ).then(res => {
      if (res.status < 400) {
        commit('getTeacherInnovativeThinkingScore', res.data)
      }
    })
  },
  getTeacherArtDesignScore({ commit }, params) {
    API.get(
      `/edu/zone/analysis/teacher/ability/artistic/dimensions`,
      params
    ).then(res => {
      if (res.status < 400) {
        commit('getTeacherArtDesignScore', res.data)
      }
    })
  },
  getTeacherLogicalThinkingScore({ commit }, params) {
    API.get(
      `/edu/zone/analysis/teacher/ability/logical/dimensions`,
      params
    ).then(res => {
      if (res.status < 400) {
        commit('getTeacherLogicalThinkingScore', res.data)
      }
    })
  },
  getTeacherProgrammingTechnologyScore({ commit }, params) {
    API.get(
      `/edu/zone/analysis/teacher/ability/programming/dimensions`,
      params
    ).then(res => {
      if (res.status < 400) {
        commit('getTeacherProgrammingTechnologyScore', res.data)
      }
    })
  },
  getTeacherComprehensiveScoreScore({ commit }, params) {
    API.get(`/edu/zone/analysis/teacher/ability/radars`, params).then(res => {
      if (res.status < 400) {
        commit('getTeacherComprehensiveScoreScore', res.data)
      }
    })
  }
}

const mutations = {
  getStudentInfo(state, data) {
    state.realName = data.real_name
    state.avatarUrl = data.avatar_url
  },
  getStudentClassNumAndClassPerformance(state, data) {
    state.courtCount = data.court_count
    state.classPerformance =
      state.classPerformanceType[data.performance_type - 1]
  },
  getStudentOpenCourse(state, data) {
    state.coursePackage = data
  },
  getStudentClassNameAndTeacher(state, data) {
    state.classInfo = data
  },
  getStudentWorkSituation(state, data) {
    state.cumulativeWork = data.cumulative_work
    state.semesterWork = data.semeste_work
  },
  getStudentWorkStarSituation(state, data) {
    state.workStarSituation = data
    let sum = 0
    for (const item in data) {
      sum += data[item]
    }
    if (sum === 0) {
      state.hasWorkStarSituationData = false
    } else {
      state.hasWorkStarSituationData = true
    }
  },
  getStudentInnovativeThinkingScore(state, data) {
    state.studentInnovativeThinkingScore = data
  },
  getStudentArtDesignScore(state, data) {
    state.studentArtDesignScore = data
  },
  getStudentLogicalThinkingScore(state, data) {
    state.studentLogicalThinkingScore = data
  },
  getStudentProgrammingTechnologyScore(state, data) {
    state.studentProgrammingTechnologyScore = data
  },
  getStudentComprehensiveScoreScore(state, data) {
    state.studentComprehensiveScoreScore = data
  },
  getTeacherInfo(state, data) {
    state.realName = data.real_name
    state.avatarUrl = data.avatar_url
  },
  getTeacherClassNumAndStudentNum(state, data) {
    state.classNum = data.class_total
    state.studentNum = data.student_total
  },
  getTeacherOpenCourse(state, data) {
    state.coursePackage = data
  },
  getTeacherClassCount(state, data) {
    state.classTotalNumSituation = data
  },
  getTeacherClassPerformance(state, data) {
    state.teacherClassPerformance = data
  },
  getTeacherClassAverageRank(state, data) {
    state.teacherClassAverageRank = data
  },
  getTeacherWorkSituationChartData(state, data) {
    state.cumulativeWork = data.cumulative_work
    state.semesterWork = data.semeste_work
  },
  getTeacherWorkCumulativeWork(state, data) {
    state.teacherWorkCumulativeWork = data
  },
  getTeacherWorkSemesterWork(state, data) {
    state.teacherWorkSemesterWork = data
  },
  getTeacherWorkStarSituation(state, data) {
    state.workStarSituation = data
    let sum = 0
    for (const item in data) {
      sum += data[item]
    }
    if (sum === 0) {
      state.hasWorkStarSituationData = false
    } else {
      state.hasWorkStarSituationData = true
    }
  },
  getTeacherWorkStarTable(state, data) {
    state.teacherWorkStarTableData = data
  },
  getTeacherClass(state, data) {
    state.teacherClassName = data
  },
  getTeacherInnovativeThinkingScore(state, data) {
    state.teacherInnovativeThinkingScore = data
  },
  getTeacherArtDesignScore(state, data) {
    state.teacherArtDesignScore = data
  },
  getTeacherProgrammingTechnologyScore(state, data) {
    state.teacherProgrammingTechnologyScore = data
  },
  getTeacherLogicalThinkingScore(state, data) {
    state.teacherLogicalThinkingScore = data
  },
  getTeacherComprehensiveScoreScore(state, data) {
    state.teacherComprehensiveScoreScore = data
  }
}

export default {
  state,
  actions,
  mutations
}
